import React, { Suspense, lazy, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ErrorBoundary from '../components/ErrorBoundary';
import AboutHero from '../components/About/AboutHero';

// Loading fallback component
const LoadingFallback = () => (
  <div className="py-20 flex justify-center items-center min-h-[300px]">
    <div className="animate-pulse text-lg font-medium text-gray-500">Loading...</div>
  </div>
);

const About: React.FC = () => {
  const [isMounted, setIsMounted] = useState(false);
  
  // Lazy-load components to improve initial page load - only when component is mounted
  const Mission = lazy(() => import('../components/About/Mission'));
  const Team = lazy(() => import('../components/About/Team'));
  // Lazy-load these when needed
  // const Journey = lazy(() => import('../components/About/Journey'));
  // const ContactCTA = lazy(() => import('../components/About/ContactCTA'));

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* AboutHero is not lazy-loaded because it's visible immediately */}
      <ErrorBoundary>
        <AboutHero />
      </ErrorBoundary>
      
      {isMounted && (
        <>
          <ErrorBoundary>
            <Suspense fallback={<LoadingFallback />}>
              <Mission />
            </Suspense>
          </ErrorBoundary>
          
          {/* <ErrorBoundary>
            <Suspense fallback={<LoadingFallback />}>
              <Journey />
            </Suspense>
          </ErrorBoundary> */}
          
          <ErrorBoundary>
            <Suspense fallback={<LoadingFallback />}>
              <Team />
            </Suspense>
          </ErrorBoundary>
          
          {/* Founder's Message Link Section */}
          <div className="py-20 bg-gradient-to-r from-slate-50 to-slate-100">
            <div className="container mx-auto px-4 md:px-6 text-center">
              <motion.div
                className="max-w-3xl mx-auto"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.8 }}
              >
                <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary mb-6">Hear From Our Founder</h2>
                <p className="text-xl text-gray-700 mb-10">
                  Discover the vision, journey, and philosophy behind Recall Nepal through the 
                  words of our founder, Durga Bahadur Karki.
                </p>
                
                <motion.div
                  whileHover={{ 
                    scale: 1.05, 
                    boxShadow: "0 15px 30px rgba(227, 6, 19, 0.3)",
                    y: -5
                  }}
                  whileTap={{ scale: 0.98 }}
                  className="inline-block"
                >
                  <Link 
                    to="/founder-message" 
                    className="px-10 py-4 bg-gradient-to-r from-primary to-secondary text-white font-bold rounded-full shadow-xl"
                  >
                    Read Founder's Message
                  </Link>
                </motion.div>
              </motion.div>
            </div>
          </div>
          
          {/* <ErrorBoundary>
            <Suspense fallback={<LoadingFallback />}>
              <ContactCTA />
            </Suspense>
          </ErrorBoundary> */}
        </>
      )}
    </div>
  );
};

export default About;